import React, { useEffect, useState } from "react";
import {
  Card,
  Input,
  Button,
  Avatar,
  Typography,
  List,
  Select,
  Row,
  Col,
  message,
  Popconfirm,
} from "antd";
import {
  SearchOutlined,
  EditOutlined,
  DeleteOutlined,
} from "@ant-design/icons";
import { motion } from "framer-motion";
import icon from "../assets/images/car.png";
import colors from "../../assets/styles/colour";
import dataService from "../../networks/api/service/dataService";
import { useNavigate } from "react-router-dom";
import { AiOutlinePlusCircle } from "react-icons/ai";
const { Title, Text } = Typography;
const { Option } = Select;

const DriverManagement = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [search, setSearch] = useState("");
  const [statusFilter, setStatusFilter] = useState("All");
  const [drivers, setDrivers] = useState([]);
  const [driversList, setDriversList] = useState(drivers);
  const navigate = useNavigate();
  useEffect(() => {
    const fetchDrivers = async () => {
      try {
        const response = await dataService.getDriver(); // Assuming it's a GET request
        console.log("Fetched Drivers:", response?.data); // Debug
        setDrivers(response?.data || []);
        setDriversList(response?.data || []);
      } catch (error) {
        console.error("Failed to fetch drivers:", error);
      }
    };

    fetchDrivers();
  }, []);
  const deleteDriver = async (id) => {
    try {
      const response = await dataService.deleteDriver(id); 
      console.log(response, "hahah")
      if (response.code === 200) {
       
        message.success("Driver deleted successfully!");
        setDriversList((prev) => prev.filter((driver) => driver._id !== id)); 
      } else {
        message.error("Failed to delete driver. Please try again.");
      }
    } catch (err) {
      console.error("Error:", err);
      message.error("Something went wrong while deleting.");
    }
  };
  const handleEdit = (driverData) => {
    navigate("/login/DriverRegistration", {
      state: { editMode: true, driverData },
    });
  };
  const filteredDrivers = driversList.filter((driver) => {
    const searchLower = searchTerm.toLowerCase();

    const matchesStatus =
      statusFilter === "All" ||
      (statusFilter === "Available" && driver.isAvailable === true) ||
      (statusFilter === "Unavailable" && driver.isAvailable === false);
  
    const searchValue = searchTerm.toLowerCase();
    const matchesSearch =
      (driver.driverName || "").toLowerCase().includes(searchValue) ||
      (driver.driverLicenseNum || "").toLowerCase().includes(searchLower);
  
    return matchesStatus && matchesSearch;
  });

  return (
    <div style={{ maxWidth: 1100, margin: "auto", padding: "20px" }}>
      
      <motion.div
  initial={{ opacity: 0, y: -20 }}
  animate={{ opacity: 1, y: 0 }}
  transition={{ duration: 0.5 }}
  style={{
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexWrap: "wrap", // Enables responsive wrapping
    gap: "10px", // Adds spacing when wrapping
    marginBottom: 20,
  }}
>
  {/* Left: Icon + Title */}
  <div
    style={{
      display: "flex",
      alignItems: "center",
      flex: 1,
      minWidth: "250px", // Allows wrapping on smaller screens
      justifyContent: "center",
    }}
  >
    <motion.img
      src={icon}
      alt="Car Icon"
      style={{ width: "50px", height: "50px", marginRight: "10px" }}
    />
    <Title level={3} style={{ margin: 0, color: colors.buttoSecondary }}>
      Driver Management
    </Title>
  </div>

  {/* Right: Button */}
  <div style={{ minWidth: "150px", textAlign: "right", flexShrink: 0 }}>
    <Button
      icon={<AiOutlinePlusCircle />}
      onClick={() => navigate("/login/DriverRegistration")}
      style={{
        backgroundColor: "rgba(128, 128, 128, 0.3)",
        borderColor: "rgba(128, 128, 128, 0.5)",
        color: "#333",
        backdropFilter: "blur(4px)",
        padding: "6px 16px",
        borderRadius: "8px",
        fontWeight: "500",
        transition: "all 0.3s ease",
        width: "100%", // Makes the button adapt on small screens
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.backgroundColor = "rgba(128, 128, 128, 0.5)";
        e.currentTarget.style.borderColor = "rgba(128, 128, 128, 0.7)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.backgroundColor = "rgba(128, 128, 128, 0.3)";
        e.currentTarget.style.borderColor = "rgba(128, 128, 128, 0.5)";
      }}
    >
      Add Driver
    </Button>
  </div>
</motion.div>


     
      
      <Row gutter={[16, 16]} style={{ marginBottom: 20 }}>
        <Col xs={24} sm={16}>
          <Input
            placeholder="Search Driver..."
            prefix={<SearchOutlined style={{ color: colors.buttoSecondary }} />}
            onChange={(e) => setSearchTerm(e.target.value)}
            style={{ width: "100%" }}
          />
        </Col>
        <Col xs={24} sm={8}>
          <Select
            style={{ width: "100%" }}
            value={statusFilter}
            onChange={(value) => setStatusFilter(value)}
          >
            <Option value="All">All</Option>
            <Option value="Available">Available</Option>
            <Option value="Unavailable">Unavailable</Option>
          </Select>
        </Col>
      </Row>

      
      <List
        dataSource={filteredDrivers}
        renderItem={(driver) => (
          <motion.div
            whileHover={{ scale: 1.03 }}
            transition={{ duration: 0.3 }}
          >
            <Card
              key={driver.id}
              onClick={() => navigate("/login/driverDetails", { state: { driver } })}
              style={{
                marginBottom: 20,
                borderRadius: 10,
                boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
              }}
            >
              <Row gutter={[16, 16]} align="middle">
                <Col xs={24} sm={6} style={{ textAlign: "center" }}>
                  <Avatar src={driver.image || "https://static.vecteezy.com/system/resources/previews/026/615/556/non_2x/driver-icon-isolated-on-white-background-vector.jpg"} size={80} />
                </Col>
                <Col xs={24} sm={14}>
                  <Title level={4} style={{ marginBottom: 5 }}>
                    {driver.driverName}
                  </Title>
                  <Text>📞 {driver.driverPhoneNumber}</Text>
                  <br />
                  <Text>📧 {driver.driverEmail}</Text>
                  <br />
                  <Text>🆔 DL Number: {driver.driverLicenseNum}</Text>
                  <br />
                  <Text>📅 DL Validity: {new Date(driver.licenceValidity).toLocaleDateString()}</Text>
<br />
<Text>
  Status:{" "}
  <b
    style={{
      color: driver.isAssigned ? "red" : "green",
      fontWeight: "bold",
    }}
  >
    {driver.isAssigned ? "Unavailable" : "Available"}
  </b>
</Text>
<br />
{driver.assignedVehicle && (
  <>
    <Text strong style={{ display: "block", marginTop: 10 }}>
      🚗 Assigned Vehicle:
    </Text>
    <Text>Type: {driver.assignedVehicle.vehicleDetails}</Text>
    <br />
    <Text>Model: {driver.assignedVehicle.makeAndModel} - {driver.assignedVehicle.registrationNum}</Text> 
    <br />
    
    <br />
  </>
)}

                </Col>
                <Col xs={24} sm={4} style={{ textAlign: "center" }}>
                  <Button
                    icon={<EditOutlined />}
                    onClick={(e) => {
                      e.stopPropagation(); 
                      handleEdit(driver);
                    }}
                    style={{
                      marginRight: 10,
                      background: colors.buttonPrimary,
                      //   color: "#fff",
                    }}
                  />
                  <Popconfirm
                  
                    title="Are you sure to delete this driver?"
                    
                    onConfirm={(e) => {
                      e?.stopPropagation(); 
                      console.log("Deleting driver:", driver);
                      deleteDriver(driver._id);
                    }}
                    onClick={(e) => e.stopPropagation()}
                    okText="Yes"
                    cancelText="No"
                  >
                    <Button icon={<DeleteOutlined />} danger
                    onClick={(e) => e.stopPropagation()}
                    />
                  </Popconfirm>
                </Col>
              </Row>
            </Card>
          </motion.div>
        )}
      />
    </div>
  );
};

export default DriverManagement;
